import logger, { VERBOSE } from "./logger";
import type { UnsubsByPath } from "./types";

export default function unsubOne(unsubsByPath: UnsubsByPath, path: string) {
  if (VERBOSE) {
    logger.log(`Unsub one "${path}"`);
  }

  const unsub = unsubsByPath[path];

  if (unsub) {
    unsub();
  }

  delete unsubsByPath[path];
}
